const axios = require("axios");
// const config = require("../../config/app.json");

axios.defaults.baseURL = process.env.VUE_APP_API_URL;
axios.defaults.headers.common["Authorization"] = localStorage.getItem("token");
axios.defaults.headers.post["Content-Type"] = "application/x-www-form-urlencoded";

module.exports.users = {
  state: () => ({
    //   logged in user
    user: {
      id: "",
      firstName: "",
      lastName: "",
      email: "",
      role: "",
      adminVerified: false,
      image: "",
      settings: "",
      assigned_number: "",
    },
  }),
  getters: {
    //   get logged in uer
    getUser: (state) => {
      return state.user;
    },
  },
  mutations: {
    //   set logged in user
    ["SET_USER"](state, user) {
      state.user = user;
      console.log(state.user);
    },
    //   update logged in user
    ["UPDATE_USER"](state, updatedUser) {
      state.user.firstName = updatedUser.firstName;
      state.user.lastName = updatedUser.lastName;
      state.user.role = updatedUser.role;
      state.user.adminVerified = updatedUser.adminVerified;
      state.user.image = updatedUser.image;
      state.user.assigned_number = updatedUser.assigned_number;
    },
  },
  actions: {
    // setting logged in user
    setUser({ commit }, updatedUser) {
      commit("SET_USER", updatedUser);
    },
    //   update logged in user
    updateUser({ commit }, updatedUser) {
      commit("UPDATE_USER", updatedUser);
    },
    // fetching logged in user
    fetchUser({ commit }) {
      axios
        .get("/api/users/self")
        .then((res) => {
          // console.log("Users Query response: ", res.data);
          commit("SET_USER", res.data.user);
        })
        .catch((err) => {
          console.log(err);
          console.log("Error in fetching user: user store");
        });
    },
  },
};
